// extracted by mini-css-extract-plugin
export var header = "_wf-1";
export var maskBottom = "_wf-6";
export var maskMiddle = "_wf-7";
export var maskTop = "_wf-5";
export var root = "_wf-0";
export var scrollDownButton = "_wf-3";
export var scrollDownButtonHidden = "_wf-4";
export var viewport = "_wf-2";